import { Container, Typography, Box } from '@mui/material';

function About() {
  return (
    <Container>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h3" gutterBottom>
          关于我
        </Typography>
        <Typography variant="body1" paragraph>
          在这里介绍你自己的经历和专业背景
        </Typography>
      </Box>
    </Container>
  );
}

export default About;